import { Link, useLocation } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";

/**
 * Sticky bottom CTA shown on mobile after the user scrolls past the hero.
 * Hidden on /contact (already converting), the AI planner (keep its form and
 * answers unobstructed), and on desktop.
 */
export function StickyMobileCTA() {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    let ticking = false;
    let last: boolean | null = null;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const next = window.scrollY > 600;
        // Only re-render on an actual transition — a setState per scroll frame
        // is the single biggest INP cost on long pages.
        if (next !== last) {
          last = next;
          setShow(next);
        }
        ticking = false;
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (pathname.startsWith("/contact") || pathname.replace(/\/$/, "") === "/ai-action-plan") return null;

  return (
    <div
      className={`lg:hidden fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 transition-transform duration-300 ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom, 0px))" }}
    >
      <div className="glass rounded-full shadow-[var(--shadow-elegant)] flex items-center gap-2 p-1.5">
        <a
          href="https://tool.freelancertamal.com/"
          target="_blank"
          rel="noopener"
          className="flex-1 inline-flex items-center justify-center gap-1.5 rounded-full border border-primary/40 text-primary px-4 py-3 text-sm font-medium"
        >
          Free audit
        </a>
        <Link
          to="/contact"
          className="flex-1 inline-flex items-center justify-center gap-1.5 rounded-full bg-primary text-primary-foreground px-4 py-3 text-sm font-medium"
        >
          Book a call <ArrowUpRight size={14} />
        </Link>
      </div>
    </div>
  );
}